// FlexPet Bundle Calculator - Complete Final Version
//
// CHANGES IN THIS VERSION (everything else is untouched):
//   1. Under-25 lb chews now ship the 30ct bag (1/2/3 pouches) instead of the 60ct.
//      Pack counts and the dosage chart are unchanged — only the SKU and units-per-bag.
//      At daily: 0.75 this takes under-25 from ~2.67x oversupply down to ~1.33x.
//   2. "Your 60-Day Supply:" was hardcoded in the inline readout and never updated.
//      It now follows the selected plan (30 / 60 / 90).
//   3. getDosageRange() had no bucket below 1.5, so 0.75 rendered as "1-2 chews".
//      Under-25 now correctly reads "½-1", matching the bag.
//   4. The form submit handler re-read the variant from #variant-selector, which only
//      contains 60ct variants — a 30ct id could not survive it and add-to-cart would
//      silently do nothing. It now trusts the calculation.
//
(function() {
  // Check if already initialized
  if (typeof window.FlexPetBundleCalculator !== 'undefined') {
    return;
  }

  /* ── Under-25 lb chews ship the 30ct bag ────────────────────────────────────
     Pack counts stay 1 / 2 / 3 — only the SKU and the units-per-bag change.
     Variant IDs: product 10553341247781 (…Maximum Strength 30 Count | Subscription)
     Skio group 78016282917 · plans 690598412581 / 690598445349 / 690598478117 (15%)
     ─────────────────────────────────────────────────────────────────────────── */
  var CHEWS_30CT = {
    unitsPerPack: 30,
    subscription: {
      1: { id: '52765722804517', price: 29.95 },   // 1 Pouch Bundle
      2: { id: '52765722837285', price: 54.95 },   // 2 Pouch Bundle
      3: { id: '52765722870053', price: 74.95 }    // 3 Pouch Bundle
    }
  };

  class FlexPetBundleCalculator {
    constructor() {
      // Core elements
      this.weightSelector = document.getElementById('pet-weight');
      this.frequencySelector = document.getElementById('delivery-frequency');
      this.dosageDisplay = document.getElementById('dosage-display');
      this.bundleDisplay = document.getElementById('bundle-display');
      this.variantSelector = document.getElementById('variant-selector');
      this.addToCartButton = document.querySelector('.btn-product-add');
      this.priceDisplay = document.querySelector('[id*="price-"]');
      this.productForm = document.querySelector('[data-type="add-to-cart-form"]');

      // Configuration
      this.config = window.FlexPetConfig || {};
      this.productType = this.detectProductType();
      this.isSubscription = this.config.isSubscription || false;

      // Dosage charts — UNCHANGED. Dosing is expressed as a range; see getDosageRange().
      this.dosageCharts = {
        maxStrength: {
          subscription: {
            '0-25': { daily: 0.75, 30: 1, 60: 2, 90: 3 },
            '25-50': { daily: 1.5, 30: 1, 60: 2, 90: 3 },
            '50-75': { daily: 2.25, 30: 2, 60: 3, 90: 4 },
            '75-100': { daily: 3, 30: 2, 60: 4, 90: 5 },
            '100+': { daily: 4, 30: 2, 60: 4, 90: 6 }
          },
          oneTime: {
            1: { price: 54.95, perUnit: 54.95 },
            2: { price: 98.95, perUnit: 49.48 },
            3: { price: 109.95, perUnit: 36.65 }
          }
        },
        regular: {
          subscription: {
            '0-25': { daily: 1.5, 30: 1, 60: 2, 90: 3 },
            '25-50': { daily: 3, 30: 2, 60: 4, 90: 5 },
            '50-75': { daily: 4.5, 30: 3, 60: 5, 90: 7 },
            '75-100': { daily: 5.25, 30: 4, 60: 7, 90: 9 },
            '100+': { daily: 5.5, 30: 4, 60: 7, 90: 10 }
          },
          oneTime: {
            1: { price: 44.95, perUnit: 44.95 },
            2: { price: 80.95, perUnit: 40.48 },
            3: { price: 89.95, perUnit: 29.98 }
          }
        }
      };

      // State
      this.currentCalculation = null;
      this.selectedWeight = '50-75';
      this.selectedQuantity = 1;
      this.selectedFrequency = 60;
      this.variantData = {};
      this.currentSellingPlanId = null;
      this.updateTimer = null;

      this.init();
    }

    detectProductType() {
      const formatValue = this.config.formatValue || '';
      if (formatValue.includes('soft_chew') || formatValue.includes('cm8') ||
          formatValue.toLowerCase().includes('soft chew') || formatValue.includes('CM8')) {
        return 'maxStrength';
      }
      return 'regular';
    }

    /* Which variant map + bag size applies right now.
       Under-25 lb chews on a subscription draw from the 30ct product; everything
       else uses the 60ct variants already present in #variant-selector. */
    packSource() {
      if (this.productType === 'maxStrength' && this.selectedWeight === '0-25' && this.isSubscription) {
        return { variants: CHEWS_30CT.subscription, unitsPerPack: CHEWS_30CT.unitsPerPack };
      }
      return { variants: this.variantData, unitsPerPack: 60 };
    }

    init() {
      console.log('FlexPet Calculator initialized. Product type:', this.productType, 'Is subscription:', this.isSubscription);

      // Hide the main price display to avoid "undefined" text
      this.hideMainPrice();

      // Load variant data
      this.loadVariantData();

      // Create weight buttons
      this.createWeightButtons();

      // Hide the dropdown frequency selector
      if (this.frequencySelector) {
        this.frequencySelector.style.display = 'none';
        const frequencySection = this.frequencySelector.closest('.frequency-selection-section');
        if (frequencySection) {
          frequencySection.style.display = 'none';
        }
      }

      if (this.isSubscription) {
        this.initSubscriptionProduct();
      } else {
        this.initOneTimeProduct();
      }

      if (this.productForm) {
        this.productForm.addEventListener('submit', (e) => {
          /* Trust the calculation, not the <select>.
             #variant-selector only ever contains 60ct variants, so a 30ct id cannot
             survive a round-trip through it — it would be blanked and we'd bail out
             below, leaving Add to Cart doing nothing at all. */
          const variantId = (this.currentCalculation && this.currentCalculation.variant)
            ? String(this.currentCalculation.variant.id)
            : (document.getElementById('variant-selector') || {}).value;

          if (!variantId) {
            console.error('No variant ID found');
            return;
          }

          console.log('Force setting variant ID to:', variantId);

          const allIdInputs = e.target.querySelectorAll('input[name="id"]');
          allIdInputs.forEach(input => {
            console.log('Updating input from:', input.value, 'to:', variantId);
            input.value = variantId;
            input.setAttribute('value', variantId);
          });

          // Capture the form data
          const formData = new FormData(e.target);
          console.log('FORM SUBMITTING - Actual FormData:');
          for (let [key, value] of formData.entries()) {
            console.log(`  ${key}: ${value}`);
          }

          console.log('Expected values:', {
            variant: e.target.querySelector('input[name="id"]')?.value,
            sellingPlan: e.target.querySelector('input[name="selling_plan"]')?.value
          });
        });
      }
    }

    hideMainPrice() {
      // Hide the main price display that shows "46.71 undefined"
      const priceElements = document.querySelectorAll('.price__container, .price--large, [id*="price-"]');
      priceElements.forEach(el => {
        if (el.textContent.includes('undefined') || el.textContent.includes('$46.71')) {
          el.style.display = 'none';
        }
      });

      const mainPriceEl = document.querySelector('#price-template--24868506108197__main');
      if (mainPriceEl) {
        mainPriceEl.style.display = 'none';
      }
    }

    initSubscriptionProduct() {
      // Setup Skio integration
      this.setupSkioIntegration();

      // Update all options on init
      this.updateAllSkioOptions();

      // Perform initial calculation after a delay to ensure Skio is ready
      setTimeout(() => {
        const checkedRadio = document.querySelector('input[name="subscription"]:checked');
        if (checkedRadio) {
          this.handleSkioSelectionChange(checkedRadio);
        }
        this.updateAllSkioOptions();
      }, 200);
    }

    setupSkioIntegration() {
      const subscriptionRadios = document.querySelectorAll('input[name="subscription"]');

      subscriptionRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          if (radio.checked) {
            this.handleSkioSelectionChange(radio);
          }
        });
      });

      const labels = document.querySelectorAll('label[for*="-6905"]');
      labels.forEach(label => {
        label.style.pointerEvents = 'auto';
      });
    }

    handleSkioSelectionChange(radio) {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }

      this.updateTimer = setTimeout(() => {
        // Extract frequency from the plan
        const planIndex = parseInt(radio.getAttribute('data-plan-index'));
        const frequencies = [30, 60, 90]; // Maps to plan indices 1, 2, 3
        this.selectedFrequency = frequencies[planIndex - 1] || 60;

        this.currentSellingPlanId = radio.value;

        console.log('Skio plan selected:', planIndex, 'Frequency:', this.selectedFrequency);

        const sellingPlanInput = document.getElementById('selling-plan-id');
        if (sellingPlanInput) {
          sellingPlanInput.value = radio.value;
          console.log('Updated selling plan ID to:', radio.value);
        } else {
          console.warn('Selling plan input not found');
          const sellingPlanByName = document.querySelector('input[name="selling_plan"]');
          if (sellingPlanByName) {
            sellingPlanByName.value = radio.value;
            console.log('Updated selling plan (by name) to:', radio.value);
          }
        }

        this.calculateSubscriptionBundle();

        const calc = this.currentCalculation;
        if (calc) {
          const unitType = this.productType === 'maxStrength' ? 'pouches' : 'bottles';
          radio.setAttribute('data-qty', `${calc.bundleSize} ${unitType}`);
        }
      }, 100);
    }

    createWeightButtons() {
      if (!this.weightSelector) return;

      this.weightSelector.style.display = 'none';

      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'weight-button-group tw-flex tw-flex-wrap tw-gap-2 tw-mt-2';

      const weightOptions = [
        { value: '0-25', label: 'Under 25 lbs' },
        { value: '25-50', label: '25-50 lbs' },
        { value: '50-75', label: '50-75 lbs' },
        { value: '75-100', label: '75-100 lbs' },
        { value: '100+', label: 'Over 100 lbs' }
      ];

      weightOptions.forEach((option, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'weight-btn';
        button.textContent = option.label;
        button.setAttribute('data-weight', option.value);

        if (index === 2) { // Default selection
          button.classList.add('active');
          this.selectedWeight = option.value;
        }

        button.addEventListener('click', () => {
          buttonContainer.querySelectorAll('.weight-btn').forEach(btn => {
            btn.classList.remove('active');
          });
          button.classList.add('active');

          this.selectedWeight = option.value;
          this.handleWeightChange();
        });

        buttonContainer.appendChild(button);
      });

      /* Inline dosage readout.
         ⚠️ The supply label used to be the literal string "Your 60-Day Supply:" —
         static text nothing ever updated, so it read "60-Day" on every plan.
         It now has its own id and is set from calc.frequency on each render.
         Placeholder values removed too: they were wrong on first paint. */
      const inlineDosageDiv = document.createElement('div');
      inlineDosageDiv.className = 'dosage-info-inline';
      inlineDosageDiv.id = 'dosage-display-inline';
      inlineDosageDiv.innerHTML = `
        <div id="inline-dosage">
          <div style="margin-bottom: 0.3rem;"><strong>Average Daily Dose:</strong> <span id="inline-dose-value"></span></div>
          <div><strong id="inline-supply-label">Your Supply:</strong> <span id="inline-supply-value"></span></div>
        </div>
      `;
      buttonContainer.appendChild(inlineDosageDiv);

      this.weightSelector.parentNode.insertBefore(buttonContainer, this.weightSelector.nextSibling);
    }

    handleWeightChange() {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }

      this.updateTimer = setTimeout(() => {
        if (this.isSubscription) {
          this.calculateSubscriptionBundle();
          this.updateAllSkioOptions();
        } else {
          this.calculateOneTimeBundle();
        }
      }, 100);
    }

    calculateSubscriptionBundle() {
      const weight = this.selectedWeight;
      const frequency = this.selectedFrequency;

      const chart = this.dosageCharts[this.productType].subscription[weight];
      if (!chart) return;

      const dailyDosage = chart.daily;
      const bundleSize = chart[frequency];
      const unitType = this.productType === 'maxStrength' ? 'pouches' : 'bottles';
      const chewType = this.productType === 'maxStrength' ? 'chews' : 'tablets';

      // Under-25 lb chews come from the 30ct product; everyone else from the 60ct.
      const src = this.packSource();
      const variant = src.variants[bundleSize];
      if (!variant) {
        console.error('No variant found for bundle size:', bundleSize);
        return;
      }

      const bundlePrice = variant.price;
      const subscriptionPrice = bundlePrice * 0.85; // 15% discount
      const monthlyPrice = subscriptionPrice / (frequency / 30);

      console.log('Bundle calculation:', {
        variantPrice: variant.price,
        bundleSize: bundleSize,
        unitsPerPack: src.unitsPerPack,
        bundlePrice: bundlePrice,
        subscriptionPrice: subscriptionPrice,
        monthlyPrice: monthlyPrice,
        frequency: frequency
      });

      this.currentCalculation = {
        weight: weight,
        frequency: frequency,
        dailyDosage: dailyDosage,
        bundleSize: bundleSize,
        // a 30ct bag is 30 chews, not 60 — without this the summary lies
        totalUnits: bundleSize * src.unitsPerPack,
        unitType: unitType,
        chewType: chewType,
        subscriptionPrice: subscriptionPrice,
        monthlyPrice: monthlyPrice,
        variant: variant
      };

      this.updateSubscriptionDisplay();
      this.updateVariantSelection(variant.id);
      this.updateAddToCartButton();
      this.addCartProperties();
    }

    updateAllSkioOptions() {
      const weight = this.selectedWeight;
      const chart = this.dosageCharts[this.productType].subscription[weight];
      if (!chart) return;

      const subscriptionRadios = document.querySelectorAll('input[name="subscription"]');

      subscriptionRadios.forEach((radio, index) => {
        const planIndex = parseInt(radio.getAttribute('data-plan-index'));
        const frequencies = [30, 60, 90];
        const frequency = frequencies[planIndex - 1] || 60;

        const bundleSize = chart[frequency];

        // Same source as the calculation, or the under-25 rows would show 60ct prices.
        const variant = this.packSource().variants[bundleSize];
        if (!variant) return;

        const bundlePrice = variant.price;
        const subscriptionPrice = bundlePrice * 0.85;
        const dailyPrice = subscriptionPrice / frequency;
        const totalSavings = bundlePrice - subscriptionPrice;
        const savingsPercent = 15;

        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          const priceEl = label.querySelector('.final_price');
          if (priceEl) {
            priceEl.textContent = `$${subscriptionPrice.toFixed(2)}`;
          }

          const monthlyPriceEl = label.querySelector('.monthly-price');
          if (monthlyPriceEl) {
            monthlyPriceEl.style.display = 'none';
          }

          const savedPrice = label.querySelector('.saved_price');
          if (savedPrice) {
            savedPrice.style.display = 'none';
          }

          radio.setAttribute('data-qty', `${bundleSize} ${this.productType === 'maxStrength' ? 'pouches' : 'bottles'}`);

          let bundleInfoEl = label.querySelector('.bundle-info-custom');
          if (!bundleInfoEl) {
            bundleInfoEl = document.createElement('div');
            bundleInfoEl.className = 'bundle-info-custom tw-mt-2';

            const planNameEl = label.querySelector('.plan-name');
            if (planNameEl && planNameEl.parentElement) {
              planNameEl.textContent = `${frequency} Day Supply`;
              planNameEl.style.fontWeight = '600';
              planNameEl.style.fontSize = '16px';

              const parentDiv = planNameEl.closest('.tw-ml-3');
              if (parentDiv) {
                parentDiv.appendChild(bundleInfoEl);
              }
            } else {
              label.appendChild(bundleInfoEl);
            }
          }

          const unitText = this.productType === 'maxStrength' ? 'pouches' : 'bottles';
          const deliveryIcon = this.getShopifyAssetUrl('noun-recycle-4716737.svg');

          bundleInfoEl.innerHTML = `
  <div class="bundle-info-wrapper" style="display: flex; justify-content: space-between; align-items: start; width: 100%; margin-top: 8px; gap: 20px;">
    <div style="flex: 1;">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
        <img src="${deliveryIcon}" alt="Delivery" style="width: 16px; height: 16px; flex-shrink: 0;" onerror="this.style.display='none'">
        <span style="font-size: 14px; color: #374151; font-weight: 500;">${bundleSize} ${unitText} delivered every ${frequency} days</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <span style="font-size: 16px; line-height: 16px; flex-shrink: 0;">ⓘ</span>
        <span style="font-size: 13px; color: #6B7280; font-weight: 500;">Pause, skip, or cancel anytime</span>
      </div>
    </div>
    <div style="text-align: right; flex-shrink: 0; min-width: 140px;">
      <div style="font-size: 16px; font-weight: 700; color: #111827; line-height: 1.2;">$${dailyPrice.toFixed(2)}/day</div>
      <div style="font-size: 11px; font-weight: 600; color: #10b981; margin-top: 4px;">
        Save $${totalSavings.toFixed(2)} (${savingsPercent}%)
      </div>
    </div>
  </div>
`;
        }
      });
    }

    updateSubscriptionDisplay() {
      const calc = this.currentCalculation;
      if (!calc) return;

      const dosageRange = this.getDosageRange(calc.dailyDosage);

      if (this.dosageDisplay) {
        this.dosageDisplay.innerHTML = `<strong>Average Daily Dose:</strong> ${dosageRange} ${calc.chewType} per day`;
      }
      if (this.bundleDisplay) {
        this.bundleDisplay.innerHTML = `<strong>Your ${calc.frequency}-Day Supply:</strong> ${calc.bundleSize} ${calc.unitType} (${calc.totalUnits} ${calc.chewType} total)`;
      }

      // Inline readout — the label follows the selected plan now.
      const inlineDoseValue = document.getElementById('inline-dose-value');
      const inlineSupplyValue = document.getElementById('inline-supply-value');
      const inlineSupplyLabel = document.getElementById('inline-supply-label');

      if (inlineSupplyLabel) {
        inlineSupplyLabel.textContent = `Your ${calc.frequency}-Day Supply:`;
      }
      if (inlineDoseValue && inlineSupplyValue) {
        inlineDoseValue.textContent = `${dosageRange} ${calc.chewType} per day`;
        inlineSupplyValue.textContent = `${calc.bundleSize} ${calc.unitType} (${calc.totalUnits} ${calc.chewType} total)`;
      }
    }

    getDosageRange(dailyDosage) {
      // If it's a whole number, just return it
      if (dailyDosage % 1 === 0) {
        return dailyDosage.toString();
      }

      // Otherwise, convert decimal dosages to ranges.
      // ⚠️ There was no bucket below 1.5, so 0.75 (under-25 lb) fell into '1-2' and the
      //    page told a 15 lb dog's owner to give 2-4x the label. The bag says ½ a chew.
      if (dailyDosage < 1) return '½-1';
      if (dailyDosage <= 1.5) return '1-2';
      if (dailyDosage <= 2.5) return '2-3';
      if (dailyDosage <= 3.5) return '3-4';
      if (dailyDosage <= 4.5) return '4-5';
      if (dailyDosage <= 5.5) return '5-6';
      return Math.ceil(dailyDosage).toString();
    }

    updateAddToCartButton() {
      if (!this.addToCartButton || !this.currentCalculation) return;

      const buttonText = this.addToCartButton.querySelector('.btn-text') || this.addToCartButton;
      const calc = this.currentCalculation;

      if (this.isSubscription && calc.subscriptionPrice) {
        this.addToCartButton.disabled = false;
        buttonText.textContent = `Add to Cart - Subscription | $${calc.subscriptionPrice.toFixed(2)}`;
      } else if (!this.isSubscription && calc.totalPrice) {
        this.addToCartButton.disabled = false;
        buttonText.textContent = `Add to Cart | $${calc.totalPrice.toFixed(2)}`;
      } else {
        buttonText.textContent = 'Select Pet Weight';
      }
    }

    updateVariantSelection(variantId) {
      if (!variantId) {
        console.error('No variant ID provided');
        return;
      }

      console.log('Updating variant selection to:', variantId);

      // NOTE: #variant-selector only holds 60ct variants, so a 30ct id won't stick here.
      // That's fine — the hidden input[name="id"] below is what actually gets submitted,
      // and the submit handler now reads from currentCalculation rather than this select.
      if (this.variantSelector) {
        this.variantSelector.value = variantId;
        this.variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const variantInputs = document.querySelectorAll('input[name="id"]');
      variantInputs.forEach(input => {
        input.value = variantId;
        console.log('Updated variant input:', input, 'to:', variantId);
      });

      const mainFormInput = this.productForm ? this.productForm.querySelector('select[name="id"], input[name="id"]') : null;
      if (mainFormInput) {
        mainFormInput.value = variantId;
        console.log('Updated main form variant input to:', variantId);
      }

      const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && this.currentSellingPlanId) {
        sellingPlanInput.value = this.currentSellingPlanId;
        console.log('Updated selling plan input to:', this.currentSellingPlanId);
      }

      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = 1;
      }

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: this.currentCalculation.variant },
        bubbles: true
      }));

      console.log('FINAL CHECK before cart submission:');
      console.log('- Variant ID being sent:', variantId);
      console.log('- Selling plan being sent:', this.currentSellingPlanId);
      console.log('- All form inputs:', {
        variant: document.querySelector('input[name="id"]')?.value,
        sellingPlan: document.querySelector('input[name="selling_plan"]')?.value,
        quantity: document.querySelector('input[name="quantity"]')?.value
      });
    }

    addCartProperties() {
      if (!this.currentCalculation || !this.productForm) return;

      const oldProps = this.productForm.querySelectorAll('input[name*="properties"]');
      oldProps.forEach(prop => prop.remove());

      const calc = this.currentCalculation;
      const productName = this.productType === 'maxStrength' ? 'Maximum Strength Soft Chews' : 'Regular Strength Tablets';
      const dosageRange = this.getDosageRange(calc.dailyDosage);

      const properties = {
        'Product Type': productName,
        'Pet Weight': this.selectedWeight + ' lbs',
        'Daily Dosage': `${dosageRange} ${calc.chewType}`,
        'Bundle Size': `${calc.bundleSize} ${calc.unitType}`,
        'Total Units': `${calc.totalUnits} ${calc.chewType}`,
        'Delivery Frequency': `Every ${calc.frequency} days`,
        'Purchase Type': 'Subscription (15% off)'
      };

      for (const [key, value] of Object.entries(properties)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        this.productForm.appendChild(input);
      }
    }

    loadVariantData() {
      const variants = {};

      if (this.variantSelector) {
        const options = this.variantSelector.querySelectorAll('option');
        console.log('Found variant options:', options.length);

        options.forEach((option, index) => {
          const bundle = parseInt(option.getAttribute('data-bundle'));
          const sku = option.getAttribute('data-sku');
          const price = parseFloat(option.getAttribute('data-price') || '0');
          const title = option.textContent.trim();

          console.log(`Variant ${index + 1}:`, { sku: sku, bundle: bundle, price: price, title: title });

          if (bundle && option.value) {
            variants[bundle] = {
              id: option.value,
              sku: sku,
              price: price,
              title: title,
              available: option.getAttribute('data-available') === 'true'
            };
            console.log(`Loaded variant - Bundle: ${bundle}, ID: ${option.value}, SKU: ${sku}, Price: $${price}`);
          }
        });
      }

      console.log('Loaded variants by bundle:', variants);

      this.variantData = variants;
    }

    getShopifyAssetUrl(filename) {
      return `https://cdn.shopify.com/s/files/1/0504/5036/6662/files/${filename}?v=1752244687`;
    }

    // ── One-time purchase methods (unchanged — always the 60ct product) ──────────

    initOneTimeProduct() {
      this.createQuantitySelector();
      this.calculateOneTimeBundle();
    }

    createQuantitySelector() {
      const quantityContainer = document.createElement('div');
      quantityContainer.className = 'quantity-selector tw-mt-4';
      quantityContainer.innerHTML = '<h3 class="customizer-heading">Step 2: Select Quantity</h3>';

      const quantityGrid = document.createElement('div');
      quantityGrid.className = 'quantity-grid quantity-grid--compact';

      const keyQuantities = [1, 3, 6, 12];
      const allQuantities = Array.from({ length: 12 }, (_, i) => i + 1);

      const singleUnitVariant = this.variantData[1];
      const singleUnitPrice = singleUnitVariant ? singleUnitVariant.price : 0;

      keyQuantities.forEach((qty) => {
        const qtyOption = this.createQuantityOption(qty, singleUnitPrice, true);
        quantityGrid.appendChild(qtyOption);
      });

      quantityContainer.appendChild(quantityGrid);

      const expandableContainer = document.createElement('div');
      expandableContainer.className = 'quantity-expand-container tw-mt-4 tw-text-center';

      const expandButton = document.createElement('button');
      expandButton.type = 'button';
      expandButton.className = 'quantity-expand-button tw-text-sm tw-underline';
      expandButton.innerHTML = '<span class="expand-text">+ View all 12 size options</span>';

      const allOptionsGrid = document.createElement('div');
      allOptionsGrid.className = 'quantity-grid-all tw-hidden tw-mt-4';
      allOptionsGrid.style.display = 'none';

      allQuantities.forEach((qty) => {
        if (!keyQuantities.includes(qty)) {
          const qtyOption = this.createQuantityOption(qty, singleUnitPrice, false);
          allOptionsGrid.appendChild(qtyOption);
        }
      });

      expandButton.addEventListener('click', () => {
        const isHidden = allOptionsGrid.style.display === 'none';
        allOptionsGrid.style.display = isHidden ? 'grid' : 'none';
        expandButton.innerHTML = isHidden
          ? '<span class="expand-text">- Hide additional options</span>'
          : '<span class="expand-text">+ View all 12 size options</span>';
      });

      expandableContainer.appendChild(expandButton);
      expandableContainer.appendChild(allOptionsGrid);
      quantityContainer.appendChild(expandableContainer);

      const weightButtonGroup = document.querySelector('.weight-button-group');
      if (weightButtonGroup) {
        weightButtonGroup.parentNode.insertBefore(quantityContainer, weightButtonGroup.nextSibling);
      }
    }

    createQuantityOption(qty, singleUnitPrice, isKeyOption = false) {
      const qtyOption = document.createElement('div');
      qtyOption.className = 'quantity-option' + (isKeyOption ? ' quantity-option--key' : '');

      const variant = this.variantData[qty];
      if (!variant) {
        console.warn('No variant found for quantity:', qty);
        return qtyOption;
      }

      const unitText = this.productType === 'maxStrength' ? 'pouch' : 'bottle';
      const unitTextPlural = qty === 1
        ? unitText.charAt(0).toUpperCase() + unitText.slice(1)
        : unitText.charAt(0).toUpperCase() + unitText.slice(1) + 's';

      const fullPrice = singleUnitPrice * qty;
      const savings = fullPrice - variant.price;
      const savingsPercent = savings > 0 ? Math.round((savings / fullPrice) * 100) : 0;

      let badge = '';
      if (qty === 3) {
        badge = '<span class="quantity-badge quantity-badge--popular">Most Popular</span>';
      } else if (qty === 12) {
        badge = '<span class="quantity-badge quantity-badge--best">Best Value</span>';
      }

      qtyOption.innerHTML = `
        ${badge}
        <div class="tw-text-center">
          <div class="quantity-amount tw-text-lg tw-font-bold">${qty} ${unitTextPlural}</div>
          <div class="quantity-price tw-text-xl tw-font-semibold">$${variant.price.toFixed(2)}</div>
          ${savings > 0 ? `
  <div class="quantity-savings tw-text-base tw-text-green-600 tw-font-semibold">
    Save $${savings.toFixed(2)}
  </div>
` : ''}
        </div>
      `;

      if (qty === 1) {
        qtyOption.classList.add('active');
      }

      qtyOption.addEventListener('click', () => {
        document.querySelectorAll('.quantity-option').forEach(opt => {
          opt.classList.remove('active');
        });
        qtyOption.classList.add('active');

        this.selectedQuantity = qty;
        this.calculateOneTimeBundle();
      });

      return qtyOption;
    }

    calculateOneTimeBundle() {
      const weight = this.selectedWeight;
      const quantity = this.selectedQuantity;

      const chart = this.dosageCharts[this.productType].subscription[weight];
      const variant = this.variantData[quantity];

      if (!chart || !variant) {
        console.error('Missing chart or variant data');
        return;
      }

      const dailyDosage = chart.daily;
      const totalUnits = quantity * 60;
      const supplyDays = Math.floor(totalUnits / dailyDosage);
      const unitType = this.productType === 'maxStrength' ? 'pouch' : 'bottle';
      const chewType = this.productType === 'maxStrength' ? 'chews' : 'tablets';

      this.currentCalculation = {
        weight: weight,
        quantity: quantity,
        dailyDosage: dailyDosage,
        totalUnits: totalUnits,
        supplyDays: supplyDays,
        unitType: unitType,
        chewType: chewType,
        totalPrice: variant.price,
        variant: variant
      };

      this.updateOneTimeDisplay();
      if (this.currentCalculation.variant) {
        this.updateVariantSelection(this.currentCalculation.variant.id);
      }
      this.updateAddToCartButton();
      this.addOneTimeCartProperties();
    }

    updateOneTimeDisplay() {
      const calc = this.currentCalculation;
      if (!calc) return;

      const dosageRange = this.getDosageRange(calc.dailyDosage);

      if (this.dosageDisplay) {
        this.dosageDisplay.innerHTML = `<strong>Average Daily Dose:</strong> ${dosageRange} ${calc.chewType} per day`;
      }
      if (this.bundleDisplay) {
        this.bundleDisplay.innerHTML = `<strong>Your Order:</strong> ${calc.quantity} ${calc.unitType}${calc.quantity > 1 ? 's' : ''} (${calc.totalUnits} ${calc.chewType} total)<br>
    <small class="tw-text-gray-600">Approximately ${calc.supplyDays} days of supply</small>`;
      }

      // No cadence on a one-time purchase, so the label shouldn't claim an N-Day Supply.
      const inlineSupplyLabel = document.getElementById('inline-supply-label');
      if (inlineSupplyLabel) {
        inlineSupplyLabel.textContent = 'Your Order:';
      }

      const inlineDoseValue = document.getElementById('inline-dose-value');
      const inlineSupplyValue = document.getElementById('inline-supply-value');
      if (inlineDoseValue && inlineSupplyValue) {
        inlineDoseValue.textContent = `${dosageRange} ${calc.chewType} per day`;
        inlineSupplyValue.textContent = `${calc.quantity} ${calc.unitType}${calc.quantity > 1 ? 's' : ''} (~${calc.supplyDays} days supply)`;
      }
    }

    addOneTimeCartProperties() {
      if (!this.currentCalculation || !this.productForm) return;

      const oldProps = this.productForm.querySelectorAll('input[name*="properties"]');
      oldProps.forEach(prop => prop.remove());

      const calc = this.currentCalculation;
      const productName = this.productType === 'maxStrength' ? 'Maximum Strength Soft Chews' : 'Regular Strength Tablets';
      const dosageRange = this.getDosageRange(calc.dailyDosage);

      const properties = {
        'Product Type': productName,
        'Pet Weight': this.selectedWeight + ' lbs',
        'Daily Dosage': `${dosageRange} ${calc.chewType}`,
        'Quantity': `${calc.quantity} ${calc.unitType}${calc.quantity > 1 ? 's' : ''}`,
        'Total Units': `${calc.totalUnits} ${calc.chewType}`,
        'Supply Duration': `~${calc.supplyDays} days`,
        'Purchase Type': 'One-time purchase'
      };

      for (const [key, value] of Object.entries(properties)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        this.productForm.appendChild(input);
      }
    }
  }

  // Make class available globally
  window.FlexPetBundleCalculator = FlexPetBundleCalculator;

  // Initialize only once
  document.addEventListener('DOMContentLoaded', () => {
    if (window.flexPetCalculator) {
      console.log('FlexPet Calculator already initialized');
      return;
    }

    // Wait for Skio to fully load
    setTimeout(() => {
      const customizer = document.getElementById('flexpet-customizer');
      const hasFlexPetProduct = window.FlexPetConfig || customizer;
      const hasSkioButtons = document.querySelector('input[name="subscription"]');

      if (hasFlexPetProduct && hasSkioButtons) {
        window.flexPetCalculator = new FlexPetBundleCalculator();
        console.log('FlexPet Bundle Calculator initialized');
      } else if (hasFlexPetProduct) {
        setTimeout(() => {
          if (!window.flexPetCalculator) {
            window.flexPetCalculator = new FlexPetBundleCalculator();
            console.log('FlexPet Bundle Calculator initialized (delayed)');
          }
        }, 500);
      }
    }, 300);
  });
})();